export interface AlertModel {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  code?: AlertCode;
  unClearOnClose?: boolean;
  fieldId?: number;
}

export enum AlertCode {
  LOAD_WATER_BALANCE = 'loadWaterBalance',
}
